"use strict";

module.exports = 2147483647;



//////////////////
// WEBPACK FOOTER
// ./node_modules/timers-ext/max-timeout.js
// module id = 719
// module chunks = 0